export const translations = {
  de: {
    // UserMenu
    profile: 'Profil',
    trips: 'Reisen',
    logout: 'Abmelden',
    darkMode: 'Dark Mode',
    lightMode: 'Light Mode',
    language: 'Sprache',

    // Trips Page
    myTrips: 'Meine Reisen',
    deleteTrip: 'Trip löschen',
    confirmDeleteTrip: 'Trip wirklich löschen?',
    confirmDeleteTripMsg: 'Diese Aktion kann nicht rückgängig gemacht werden.',
    tripDeleted: 'Trip gelöscht',
    tripInviteAccepted2: 'Einladung angenommen — willkommen im Trip!',
    tripInviteDeclined2: 'Einladung abgelehnt',
    createTrip: 'Neue Reise erstellen',
    noTrips: 'Noch keine Reisen',
    startCreating: 'Erstellen Sie Ihre erste Reise!',
    participants: 'Teilnehmer',
    redirecting: 'Weiterleitung...',
    backToOverview: 'Zurück zur Übersicht',
    loadingTrip: 'Lade Trip...',
    errorLoadingTrips: 'Fehler beim Laden der Reisen',
    dashboard: 'Dashboard',
    tripSingular: 'Reise',
    tripPlural: 'Reisen',
    openTrip: 'Reise öffnen',
    travelDashboardTitle: 'Reise-Übersicht',
    travelDashboardSubtitle: 'Plane Reisen, verwalte Orte und teile Ausgaben mit Freunden.',
    quickAccess: 'Schnellzugriff',
    manageFriends: 'Freunde verwalten',
    recentTrips: 'Letzte Reisen',
    createFirstTripHint: 'Erstelle deine erste Reise und lade Freunde ein.',
    createFirstTrip: 'Erste Reise erstellen',
    viewAllTrips: 'Alle Reisen anzeigen',
    friendsManageDesc: 'Verwalte deine Freunde und sende Anfragen.',
    copyCode: 'Code kopieren',
    enterFriendCode: 'Freundes-Code eingeben…',
    tripInvitesDesc: 'Reise-Einladungen von deinen Freunden.',
    noTripInvitationsHint: 'Wenn dich jemand zu einer Reise einlädt, siehst du es hier.',

    // Trip Detail
    locations: 'Orte',
    finances: 'Finanzen',
    chat: 'Chat',

    // Locations
    addLocation: 'Neuen Ort hinzufügen',
    map: 'Karte',
    myLocations: 'Meine Orte',
    visited: 'Besucht',
    toVisit: 'Zu besuchen',
    noLocations: 'Noch keine Orte hinzugefügt',
    addFirstLocation: 'Fügen Sie Ihren ersten Ort hinzu!',
    selectForRoute: 'Für Route auswählen',
    selectedForRoute: 'Für Route ausgewählt',
    yourPosition: 'Deine Position',
    youAreHere: 'Du bist hier',
    locationNameLabel: 'Name des Ortes',
    selectCategory: 'Kategorie wählen',
    streetAddress: 'Straße, Hausnummer, PLZ',
    stars: 'Sterne',
    star: 'Stern',
    alreadyVisited: 'Bereits besucht',
    saveLocation: 'Ort speichern',
    searching: 'Suche...',
    noLocationsFound: 'Keine Orte gefunden',
    minCharsRequired: 'Mindestens 2 Zeichen eingeben',
    results: 'Ergebnisse',
    result: 'Ergebnis',

    // Route Planner
    routePlanning: 'Route planen',
    locationsSelected: 'Orte ausgewählt',
    location: 'Ort',
    optimizeRoute: 'Route optimieren',
    optimizing: 'Optimiere...',
    startNavigation: 'Navigation starten',
    chooseNavigation: 'Navigation wählen',
    selectMinTwo: 'Wähle mindestens 2 Orte aus, um die Route zu optimieren',
    allLocations: 'Alle Orte',
    firstLocationOnly: 'Nur 1. Ort',

    // Location Categories
    restaurant: 'Restaurant',
    cafe: 'Café',
    museum: 'Museum',
    park: 'Park',
    attraction: 'Sehenswürdigkeit',
    shopping: 'Shopping',
    bar: 'Bar',
    hotel: 'Hotel',
    other: 'Sonstiges',

    // Location Form
    locationName: 'Ortsname',
    category: 'Kategorie',
    address: 'Adresse',
    rating: 'Bewertung',
    notes: 'Notizen',
    save: 'Speichern',
    cancel: 'Abbrechen',

    // Finances
    expenses: 'Ausgaben',
    newExpense: 'Neue Ausgabe hinzufügen',
    noExpenses: 'Noch keine Ausgaben eingetragen',
    addFirstExpense: 'Fügen Sie Ihre erste Ausgabe hinzu!',
    totalExpenses: 'Gesamtausgaben',
    perPerson: 'Pro Person',
    members: 'Mitglieder',
    exportPDF: 'Export PDF (mit Quittungen)',
    exportCSV: 'Export CSV',
    description: 'Beschreibung',
    amount: 'Betrag',
    paidBy: 'Bezahlt von',
    expenseDate: 'Datum',
    receipt: 'Quittung',
    uploadReceipt: 'Quittung hochladen',
    hasReceipt: 'Hat Quittung',
    viewReceipt: 'Quittung ansehen',
    hideReceipt: 'Quittung ausblenden',
    openFullscreen: 'Vollbild öffnen',
    selectParticipants: 'Teilnehmer auswählen',
    splitEqually: 'Gleichmäßig teilen',
    debtSettlement: 'Schuldenausgleich',
    whoPaysWhom: 'Wer zahlt wem',
    youOwe: 'Du schuldest',
    owesYou: 'schuldet dir',
    settled: 'Ausgeglichen',
    expensesByCategory: 'Ausgaben nach Kategorie',
    expensesOverTime: 'Ausgaben über Zeit',
    selectPerson: 'Person wählen',
    saveExpense: 'Ausgabe speichern',
    amountEur: 'Betrag (€)',
    clickToUpload: 'Klicken zum Hochladen oder Datei hierher ziehen',
    maxFileSize: 'PNG, JPG bis 5MB',
    splitAmong: 'Wird aufgeteilt auf',
    person: 'Person',
    persons: 'Personen',
    collapse: 'Einklappen',
    selectedOf: 'von',
    selected: 'ausgewählt',
    deselectAll: 'Alle abwählen',
    selectAll: 'Alle auswählen',
    fileTooLarge: 'Datei ist zu groß. Maximal 5MB erlaubt.',
    onlyImages: 'Nur Bilder sind erlaubt.',
    createdBy: 'von',
    unknown: 'Unbekannt',
    avgPerDay: 'Durchschnitt/Tag',
    highestExpense: 'Höchste Ausgabe',

    // Debt Settlement
    debtSettlementTitle: 'Abrechnung & Schulden',
    balance: 'Kontostand',
    paid: 'Bezahlt',
    share: 'Anteil',
    getsBack: 'Bekommt zurück',
    owes: 'Schuldet',
    fullySettled: 'Vollständig ausgeglichen!',
    openPayments: 'Offene Zahlungen',
    allDebtsSettled: 'Alle Schulden sind ausgeglichen!',
    noOneOwes: 'Niemand schuldet niemandem etwas.',
    pays: 'Zahlt',
    receives: 'Erhält',
    settlementTip: 'Die Abrechnung ist optimiert und minimiert die Anzahl der notwendigen Transaktionen.',

    // Trip Finance Overview
    tripOverview: 'Trip Übersicht',
    myTotalExpenses: 'Meine Gesamtausgaben',
    overviewByParticipant: 'Übersicht nach Teilnehmer',
    gets: 'Bekommt',
    // Finance Overview
    totalExpensesSubtitle: 'Alle Ausgaben dieser Reise',
    totalAmount: 'Gesamtbetrag',
    totalAmountSubtitle: 'Summe aller Ausgaben',
    participantsSubtitle: 'Personen in dieser Reise',
    avgPerPerson: 'Ø Pro Person',
    avgPerPersonSubtitle: 'Gleichmäßige Aufteilung',
    sharePerParticipant: 'Anteil je Teilnehmer',
    paymentView: 'Payment View',
    paymentViewSubtitle: 'Bezahlt und Schulden pro Person',
    morePaid: '% mehr bezahlt',
    stillOpen: '% noch offen',
    owesStill: 'Schuldet noch',

    // Expense Categories
    food: 'Essen',
    transport: 'Transport',
    accommodation: 'Unterkunft',
    activities: 'Aktivitäten',
    groceries: 'Lebensmittel',
    entertainment: 'Unterhaltung',

    // Profile
    profileSettings: 'Profileinstellungen',
    personalInfo: 'Persönliche Informationen',
    displayName: 'Anzeigename',
    email: 'E-Mail',
    profilePicture: 'Profilbild',
    uploadNewPicture: 'Neues Bild hochladen',
    removePicture: 'Bild entfernen',
    updateProfile: 'Profil aktualisieren',
    accountSettings: 'Kontoeinstellungen',
    changePassword: 'Passwort ändern',
    deleteAccount: 'Konto löschen',
    back: 'Zurück',
    editProfile: 'Profil bearbeiten',
    bio: 'Bio',
    website: 'Webseite',
    joined: 'Beigetreten',
    saveChanges: 'Änderungen speichern',
    saving: 'Speichert...',
    newPassword: 'Neues Passwort',
    confirmPassword: 'Neues Passwort bestätigen',
    updatePassword: 'Passwort aktualisieren',
    changing: 'Wird geändert...',
    clickToUploadAvatar: 'Klicken für neues Profilbild',
    maxAvatarSize: 'Max 2MB (JPG, PNG)',
    manageProfileSecurity: 'Profil und Sicherheit verwalten',
    keepAccountSecure: 'Aktualisieren Sie Ihr Passwort für mehr Sicherheit',
    passwordsNoMatch: 'Passwörter stimmen nicht überein!',
    passwordTooShort: 'Passwort muss mindestens 6 Zeichen lang sein!',
    profileUpdated: 'Profil erfolgreich aktualisiert!',
    profileUpdateFailed: 'Profil konnte nicht aktualisiert werden.',
    passwordChanged: 'Passwort erfolgreich geändert!',
    passwordChangeFailed: 'Passwort konnte nicht geändert werden.',
    avatarUpdated: 'Profilbild aktualisiert!',
    avatarUploadFailed: 'Profilbild konnte nicht hochgeladen werden.',
    uploadImageOnly: 'Bitte laden Sie ein Bild hoch.',
    imageTooLarge: 'Bild muss kleiner als 2MB sein.',
    loadingProfile: 'Profil wird geladen...',
    enterName: 'Geben Sie Ihren Namen ein',
    aboutYou: 'Erzählen Sie etwas über sich',
    searchYourLocation: 'Nach Ihrem Standort suchen...',

    // Auth - Signup
    createAccount: 'Konto erstellen',
    createYourAccount: 'Erstellen Sie Ihr Finance App Konto',
    accountCreated: 'Konto erfolgreich erstellt! Sie werden weitergeleitet...',
    continueWithGoogle: 'Mit Google fortfahren',
    continueWithApple: 'Mit Apple fortfahren',
    continueWithGithub: 'Mit GitHub fortfahren',
    orWithEmail: 'Oder mit E-Mail',
    name: 'Name',
    password: 'Passwort',
    yourName: 'Ihr Name',
    yourEmail: 'ihre@email.com',
    minChars: 'Mindestens 6 Zeichen',
    minCharsRequired2: 'Mindestens 6 Zeichen erforderlich',
    creating: 'Wird erstellt...',
    alreadyHaveAccount: 'Haben Sie bereits ein Konto?',
    signIn: 'Anmelden',
    genericError: 'Ein Fehler ist aufgetreten',
    notLoggedIn: 'Nicht angemeldet',

    // Auth - Login (for pages using custom translations)
    loginTitle: 'Willkommen zurück',
    loginSubtitle: 'Melden Sie sich bei Ihrem Konto an',
    forgotPassword: 'Passwort vergessen?',
    noAccount: 'Noch kein Konto?',
    signUp: 'Registrieren',
    loggingIn: 'Wird angemeldet...',

    // Auth - Reset Password
    resetPassword: 'Passwort zurücksetzen',
    resetPasswordDesc: 'Geben Sie Ihre E-Mail-Adresse ein und wir senden Ihnen einen Link zum Zurücksetzen.',
    sendResetLink: 'Link senden',
    sending: 'Wird gesendet...',
    resetLinkSent: 'Wir haben Ihnen eine E-Mail mit einem Link zum Zurücksetzen Ihres Passworts gesendet. Bitte überprüfen Sie Ihren Posteingang.',
    backToLogin: 'Zurück zur Anmeldung',

    // Auth - Update Password
    setNewPassword: 'Neues Passwort festlegen',
    setNewPasswordDesc: 'Geben Sie Ihr neues Passwort ein.',
    passwordUpdated: 'Passwort erfolgreich aktualisiert! Sie werden weitergeleitet...',
    updatingPassword: 'Wird aktualisiert...',
    invalidResetLink: 'Ungültiger oder abgelaufener Link. Bitte fordern Sie einen neuen an.',
    requestNewLink: 'Neuen Link anfordern',
    emailAddressLabel: 'E-Mail-Adresse',
    checkYourEmail: 'Überprüfen Sie Ihre E-Mails',
    enterEmailAddress: 'Geben Sie Ihre E-Mail-Adresse ein',
    emailSentTitle: 'E-Mail wurde gesendet!',
    openMailbox: 'Öffnen Sie Ihr E-Mail-Postfach',
    clickEmailLink: 'Klicken Sie auf den Link in der E-Mail',
    useOtherEmail: 'Andere E-Mail-Adresse verwenden',
    securePasswordHint: 'Wählen Sie ein sicheres neues Passwort',
    passwordRequirementsInfo: 'Ihr neues Passwort sollte mindestens 6 Zeichen lang sein und sich von Ihrem alten Passwort unterscheiden.',
    passwordUpdatedSuccess: 'Passwort erfolgreich aktualisiert!',
    redirectingToLogin: 'Sie werden zur Anmeldeseite weitergeleitet...',
    repeatPassword: 'Passwort wiederholen',
    passwordsMatch: 'Passwörter stimmen überein',
    passwordsDontMatch: 'Passwörter stimmen nicht überein',
    passwordMismatch: 'Die Passwörter stimmen nicht überein',
    goToLogin: 'Zur Anmeldung',

    // Auth - Confirm Email
    confirmEmail: 'E-Mail bestätigen',
    confirmEmailDesc: 'Wir haben Ihnen eine E-Mail gesendet. Bitte bestätigen Sie Ihre E-Mail-Adresse.',
    resendEmail: 'E-Mail erneut senden',

    // Trip Creation
    createNewTrip: 'Neue Reise erstellen',
    tripName: 'Reisename',
    destination: 'Ziel',
    startDate: 'Startdatum',
    endDate: 'Enddatum',
    addMembers: 'Mitglieder hinzufügen',
    searchUsers: 'Benutzer suchen',
    tripDescription: 'Beschreiben Sie Ihren Trip...',
    tripNamePlaceholder: 'z.B. Amsterdam Wochenende',
    destinationPlaceholder: 'z.B. Amsterdam, Niederlande',
    descriptionOptional: 'Beschreibung (optional)',
    startDateOptional: 'Startdatum (optional)',
    endDateOptional: 'Enddatum (optional)',
    whenStart: 'Wann beginnt Ihre Reise?',
    whenEnd: 'Wann endet Ihre Reise?',
    addTravelCompanions: 'Reisebegleiter hinzufügen',
    searchByNameOrEmail: 'Nach Name oder E-Mail suchen...',
    creatingTrip: 'Wird erstellt...',
    createTripButton: 'Trip erstellen',
    inviteCompanions: 'Erstellen Sie einen Trip und laden Sie Ihre Reisebegleiter ein',
    createError: 'Fehler beim Erstellen des Trips',

    // Trip Members
    manageMembers: 'Mitglieder verwalten',
    currentMembers: 'Aktuelle Mitglieder',
    addMember: 'Mitglied hinzufügen',
    removeMember: 'Entfernen',
    selectUser: 'Benutzer auswählen',
    noMembers: 'Keine Mitglieder',
    memberAdded: 'Mitglied hinzugefügt',
    memberRemoved: 'Mitglied entfernt',
    role: 'Rolle',
    owner: 'Eigentümer',
    member: 'Mitglied',
    allUsersAreMembersAlready: 'Alle verfügbaren Benutzer sind bereits Mitglieder',

    // Chat
    tripChat: 'Trip Chat',
    noMessages: 'Noch keine Nachrichten',
    startConversation: 'Starte die Unterhaltung!',
    writeMessage: 'Nachricht schreiben...',
    send: 'Senden',
    deleteMessage: 'Nachricht löschen?',
    edit: 'Bearbeiten',
    delete: 'Löschen',
    edited: '(bearbeitet)',
    replyTo: 'Antworten auf',
    addReaction: 'Reaktion hinzufügen',
    read: 'Gelesen',
    sent: 'Gesendet',
    you: 'Du',

    // Friends & Invitations
    friends: 'Freunde',
    friendsTab: 'Freunde',
    myFriendCode: 'Mein Code',
    friendCodeHint: 'Teile diesen Code, damit andere dich als Freund hinzufügen können',
    friendCodeCopied: 'Code kopiert!',
    addFriend: 'Freund hinzufügen',
    searchFriends: 'Freunde suchen...',
    friendCodePlaceholder: 'z.B. XK29FPQ3',
    sendFriendRequest: 'Anfrage senden',
    sendingRequest: 'Wird gesendet...',
    friendRequestSent: 'Freundschaftsanfrage gesendet!',
    friendRequests: 'Freundschaftsanfragen',
    incomingRequests: 'Eingehend',
    outgoingRequests: 'Ausgehend',
    noFriendRequests: 'Keine offenen Anfragen',
    accept: 'Annehmen',
    decline: 'Ablehnen',
    removeFriend: 'Freund entfernen',
    cancelRequest: 'Anfrage zurückziehen',
    friendAccepted: 'Freundschaft angenommen!',
    friendDeclined: 'Anfrage abgelehnt',
    friendRemoved: 'Freund entfernt',
    confirmRemoveFriend: 'Wirklich entfernen?',
    confirmRemoveFriendMsg: 'Möchtest du diesen Freund wirklich entfernen?',
    noFriends: 'Noch keine Freunde',
    noFriendsHint: 'Teile deinen Code oder gib den Code eines Freundes ein',
    friendAdded: 'Freund hinzugefügt!',
    alreadyFriends: 'Ihr seid bereits Freunde',
    requestAlreadySent: 'Anfrage bereits gesendet',
    userNotFound: 'Benutzer nicht gefunden',
    cannotAddYourself: 'Du kannst dich nicht selbst hinzufügen',
    inviteToTrip: 'Zum Trip einladen',
    tripInvitations: 'Trip-Einladungen',
    pendingTripInvites: 'Offene Trip-Einladungen',
    noTripInvitations: 'Keine offenen Einladungen',
    tripInviteSent: 'Einladung gesendet',
    tripInviteAccepted: 'Einladung angenommen',
    tripInviteDeclined: 'Einladung abgelehnt',
    alreadyInvited: 'Bereits eingeladen',
    alreadyMember: 'Bereits Mitglied',
    canOnlyInviteFriends: 'Nur Freunde können eingeladen werden',
    invitedBy: 'Eingeladen von',
    pendingInvite: 'Ausstehend',
    onlyFriendsCanBeAdded: 'Nur Freunde können zu Trips hinzugefügt werden',

    // Planning
    planningTab: 'Planung',
    stages: 'Etappen',
    addStage: 'Etappe hinzufügen',
    editStage: 'Etappe bearbeiten',
    stageName: 'Etappenname',
    stageNamePh: 'z.B. Tag 1: Startpunkt → Endpunkt',
    startPoint: 'Startpunkt',
    endPoint: 'Endpunkt',
    distanceKm: 'Distanz (km)',
    elevationGainM: 'Höhenmeter (m)',
    naismithTime: 'Naismith-Zeit',
    gpxImport: 'GPX importieren',
    gpxImportHint: 'GPX-Datei hochladen um Distanz und Höhenprofil automatisch zu berechnen',
    stageAutoCalc: 'Distanz & Höhe automatisch berechnen',
    stageCalcLoading: 'Berechne Route…',
    stageCalcLocationError: 'Ort nicht gefunden',
    stageCalcRouteError: 'Route konnte nicht berechnet werden',
    stageCalcFallback: '⚠ Route nicht verfügbar – Luftlinie berechnet (×1.35)',
    stageCalcElevError: 'Höhenprofil nicht verfügbar',
    locationSearchPh: 'Ort suchen…',
    routePreview: 'Routenvorschau',
    overviewMap: 'Alle Etappen',
    stageMapLabel: 'Routenkarte',
    shareStory: 'Story erstellen',
    downloadStory: 'Story herunterladen',
    shareInstagramHint: 'In Instagram teilen',
    stageLabel: 'Etappe',
    noStages: 'Noch keine Etappen',
    noStagesHint: 'Füge Etappen hinzu um die Route zu planen',
    totalDistance: 'Gesamtdistanz',
    totalElevation: 'Gesamthöhenmeter',
    estimatedTime: 'Geschätzte Zeit',
    elevationProfile: 'Höhenprofil',
    elevationM: 'Höhe (m)',
    distanceKmAxis: 'Distanz (km)',
    deleteStage: 'Etappe löschen',
    saveStage: 'Speichern',
    cancelStage: 'Abbrechen',
    weather: 'Wetter',
    weatherFor: 'Wetter für',
    weatherLoading: 'Wetter wird geladen...',
    weatherUnavailable: 'Wetter nicht verfügbar',
    precipMm: 'Niederschlag',
    windKmh: 'Wind',
    trailConditions: 'Wegzustand',
    reportCondition: 'Zustand melden',
    conditionTag: 'Zustand',
    conditionNote: 'Notiz (optional)',
    conditionGreat: 'Ausgezeichnet',
    conditionWet: 'Nass',
    conditionMuddy: 'Matschig',
    conditionIcy: 'Vereist',
    conditionOvergrown: 'Überwachsen',
    conditionDamaged: 'Beschädigt',
    conditionClosed: 'Gesperrt',
    conditionOther: 'Sonstiges',
    noConditions: 'Noch keine Zustandsmeldungen',
    reportedBy: 'Gemeldet von',
    conditionForStage: 'Für Etappe (optional)',
    allStages: 'Alle Etappen',
    submit: 'Absenden',

    // Currency
    baseCurrency: 'Basiswährung',
    baseCurrencyHint: 'Alle Ausgaben werden in diese Währung umgerechnet',
    expenseCurrency: 'Währung',
    exchangeRate: 'Wechselkurs',
    exchangeRateHint: '1 {currency} = ? {base}',
    currencySettings: 'Währungseinstellungen',
    saveCurrency: 'Speichern',
    originalAmount: 'Originalbetrag',
    convertedAmount: 'Umgerechnet',
    rateLabel: 'Kurs',

    // General
    loading: 'Lädt...',
    error: 'Fehler',
    success: 'Erfolg',
  },
  en: {
    // UserMenu
    profile: 'Profile',
    trips: 'Trips',
    logout: 'Sign Out',
    darkMode: 'Dark Mode',
    lightMode: 'Light Mode',
    language: 'Language',

    // Trips Page
    myTrips: 'My Trips',
    deleteTrip: 'Delete Trip',
    confirmDeleteTrip: 'Delete this trip?',
    confirmDeleteTripMsg: 'This action cannot be undone.',
    tripDeleted: 'Trip deleted',
    tripInviteAccepted2: 'Invitation accepted — welcome to the trip!',
    tripInviteDeclined2: 'Invitation declined',
    createTrip: 'Create New Trip',
    noTrips: 'No trips yet',
    startCreating: 'Create your first trip!',
    participants: 'Participants',
    redirecting: 'Redirecting...',
    backToOverview: 'Back to overview',
    loadingTrip: 'Loading trip...',
    errorLoadingTrips: 'Error loading trips',
    dashboard: 'Dashboard',
    tripSingular: 'Trip',
    tripPlural: 'Trips',
    openTrip: 'Open trip',
    travelDashboardTitle: 'Travel Overview',
    travelDashboardSubtitle: 'Plan trips, manage places, and share expenses with friends.',
    quickAccess: 'Quick Access',
    manageFriends: 'Manage friends',
    recentTrips: 'Recent trips',
    createFirstTripHint: 'Create your first trip and invite friends.',
    createFirstTrip: 'Create first trip',
    viewAllTrips: 'View all trips',
    friendsManageDesc: 'Manage your friends and send requests.',
    copyCode: 'Copy code',
    tripInvitesDesc: 'Trip invitations from your friends.',
    noTripInvitationsHint: 'If someone invites you to a trip, you will see it here.',

    // Trip Detail
    locations: 'Locations',
    finances: 'Finances',
    chat: 'Chat',

    // Locations
    addLocation: 'Add New Location',
    map: 'Map',
    myLocations: 'My Locations',
    visited: 'Visited',
    toVisit: 'To visit',
    noLocations: 'No locations added yet',
    addFirstLocation: 'Add your first location!',
    selectForRoute: 'Select for route',
    selectedForRoute: 'Selected for route',
    yourPosition: 'Your Position',
    youAreHere: 'You are here',
    locationNameLabel: 'Location name',
    selectCategory: 'Select category',
    streetAddress: 'Street, number, postcode',
    stars: 'Stars',
    star: 'Star',
    alreadyVisited: 'Already visited',
    saveLocation: 'Save location',
    searching: 'Searching...',
    noLocationsFound: 'No locations found',
    minCharsRequired: 'Enter at least 2 characters',
    results: 'Results',
    result: 'Result',

    // Route Planner
    routePlanning: 'Route Planning',
    locationsSelected: 'locations selected',
    location: 'location',
    optimizeRoute: 'Optimize Route',
    optimizing: 'Optimizing...',
    startNavigation: 'Start Navigation',
    chooseNavigation: 'Choose Navigation',
    selectMinTwo: 'Select at least 2 locations to optimize the route',
    allLocations: 'All locations',
    firstLocationOnly: 'First location only',

    // Location Categories
    restaurant: 'Restaurant',
    cafe: 'Café',
    museum: 'Museum',
    park: 'Park',
    attraction: 'Attraction',
    shopping: 'Shopping',
    bar: 'Bar',
    hotel: 'Hotel',
    other: 'Other',

    // Location Form
    locationName: 'Location Name',
    category: 'Category',
    address: 'Address',
    rating: 'Rating',
    notes: 'Notes',
    save: 'Save',
    cancel: 'Cancel',

    // Finances
    expenses: 'Expenses',
    newExpense: 'Add New Expense',
    noExpenses: 'No expenses yet',
    addFirstExpense: 'Add your first expense!',
    totalExpenses: 'Total Expenses',
    perPerson: 'Per Person',
    members: 'Members',
    exportPDF: 'Export PDF (with receipts)',
    exportCSV: 'Export CSV',
    description: 'Description',
    amount: 'Amount',
    paidBy: 'Paid by',
    expenseDate: 'Date',
    receipt: 'Receipt',
    uploadReceipt: 'Upload receipt',
    hasReceipt: 'Has receipt',
    viewReceipt: 'View receipt',
    hideReceipt: 'Hide receipt',
    openFullscreen: 'Open fullscreen',
    selectParticipants: 'Select participants',
    splitEqually: 'Split equally',
    debtSettlement: 'Debt Settlement',
    whoPaysWhom: 'Who pays whom',
    youOwe: 'You owe',
    owesYou: 'owes you',
    settled: 'Settled',
    expensesByCategory: 'Expenses by Category',
    expensesOverTime: 'Expenses Over Time',
    selectPerson: 'Select person',
    saveExpense: 'Save expense',
    amountEur: 'Amount (€)',
    clickToUpload: 'Click to upload or drag file here',
    maxFileSize: 'PNG, JPG up to 5MB',
    splitAmong: 'Split among',
    person: 'person',
    persons: 'persons',
    collapse: 'Collapse',
    selectedOf: 'of',
    selected: 'selected',
    deselectAll: 'Deselect all',
    selectAll: 'Select all',
    fileTooLarge: 'File is too large. Maximum 5MB allowed.',
    onlyImages: 'Only images are allowed.',
    createdBy: 'by',
    unknown: 'Unknown',
    avgPerDay: 'Average/Day',
    highestExpense: 'Highest Expense',

    // Debt Settlement
    debtSettlementTitle: 'Settlement & Debts',
    balance: 'Balance',
    paid: 'Paid',
    share: 'Share',
    getsBack: 'Gets back',
    owes: 'Owes',
    fullySettled: 'Fully settled!',
    openPayments: 'Open Payments',
    allDebtsSettled: 'All debts are settled!',
    noOneOwes: 'Nobody owes anyone anything.',
    pays: 'Pays',
    receives: 'Receives',
    settlementTip: 'The settlement is optimized and minimizes the number of necessary transactions.',

    // Trip Finance Overview
    tripOverview: 'Trip Overview',
    myTotalExpenses: 'Total Expenses',
    overviewByParticipant: 'Overview by Participant',
    gets: 'Gets',
    // Finance Overview
    totalExpensesSubtitle: 'All expenses of this trip',
    totalAmount: 'Total Amount',
    totalAmountSubtitle: 'Sum of all expenses',
    participantsSubtitle: 'People on this trip',
    avgPerPerson: 'Avg Per Person',
    avgPerPersonSubtitle: 'Equal split',
    sharePerParticipant: 'Share per participant',
    paymentView: 'Payment View',
    paymentViewSubtitle: 'Paid and owed per person',
    morePaid: '% more than share',
    stillOpen: '% still open',
    owesStill: 'Owes',

    // Expense Categories
    food: 'Food',
    transport: 'Transport',
    accommodation: 'Accommodation',
    activities: 'Activities',
    groceries: 'Groceries',
    entertainment: 'Entertainment',

    // Profile
    profileSettings: 'Profile Settings',
    personalInfo: 'Personal Information',
    displayName: 'Display Name',
    email: 'Email',
    profilePicture: 'Profile Picture',
    uploadNewPicture: 'Upload new picture',
    removePicture: 'Remove picture',
    updateProfile: 'Update Profile',
    accountSettings: 'Account Settings',
    changePassword: 'Change Password',
    deleteAccount: 'Delete Account',
    back: 'Back',
    editProfile: 'Edit Profile',
    bio: 'Bio',
    website: 'Website',
    joined: 'Joined',
    saveChanges: 'Save Changes',
    saving: 'Saving...',
    newPassword: 'New Password',
    confirmPassword: 'Confirm New Password',
    updatePassword: 'Update Password',
    changing: 'Changing...',
    clickToUploadAvatar: 'Click to upload new avatar',
    maxAvatarSize: 'Max 2MB (JPG, PNG)',
    manageProfileSecurity: 'Manage your profile information and security',
    keepAccountSecure: 'Update your password to keep your account secure',
    passwordsNoMatch: 'New passwords do not match!',
    passwordTooShort: 'Password must be at least 6 characters long!',
    profileUpdated: 'Profile updated successfully!',
    profileUpdateFailed: 'Failed to update profile. Please try again.',
    passwordChanged: 'Password changed successfully!',
    passwordChangeFailed: 'Failed to change password. Please try again.',
    avatarUpdated: 'Avatar updated successfully!',
    avatarUploadFailed: 'Failed to upload avatar. Please try again.',
    uploadImageOnly: 'Please upload an image file.',
    imageTooLarge: 'Image must be less than 2MB.',
    loadingProfile: 'Loading profile...',
    enterName: 'Enter your name',
    aboutYou: 'Tell us about yourself',
    searchYourLocation: 'Search for your location...',

    // Auth - Signup
    createAccount: 'Create Account',
    createYourAccount: 'Create your Finance App account',
    accountCreated: 'Account created successfully! Redirecting...',
    continueWithGoogle: 'Continue with Google',
    continueWithApple: 'Continue with Apple',
    continueWithGithub: 'Continue with GitHub',
    orWithEmail: 'Or with email',
    name: 'Name',
    password: 'Password',
    yourName: 'Your name',
    yourEmail: 'your@email.com',
    minChars: 'At least 6 characters',
    minCharsRequired2: 'At least 6 characters required',
    creating: 'Creating...',
    alreadyHaveAccount: 'Already have an account?',
    signIn: 'Sign In',
    genericError: 'An error occurred',
    notLoggedIn: 'Not logged in',

    // Auth - Login
    loginTitle: 'Welcome back',
    loginSubtitle: 'Sign in to your account',
    forgotPassword: 'Forgot password?',
    noAccount: "Don't have an account?",
    signUp: 'Sign Up',
    loggingIn: 'Signing in...',

    // Auth - Reset Password
    resetPassword: 'Reset Password',
    resetPasswordDesc: 'Enter your email and we will send you a reset link.',
    sendResetLink: 'Send Reset Link',
    sending: 'Sending...',
    resetLinkSent: 'We sent you an email with a link to reset your password. Please check your inbox.',
    backToLogin: 'Back to login',

    // Auth - Update Password
    setNewPassword: 'Set New Password',
    setNewPasswordDesc: 'Enter your new password.',
    passwordUpdated: 'Password updated successfully! Redirecting...',
    updatingPassword: 'Updating...',
    invalidResetLink: 'Invalid or expired link. Please request a new one.',
    requestNewLink: 'Request new link',
    emailAddressLabel: 'Email address',
    checkYourEmail: 'Check your email',
    enterEmailAddress: 'Enter your email address',
    emailSentTitle: 'Email sent!',
    openMailbox: 'Open your email inbox',
    clickEmailLink: 'Click the link in the email',
    useOtherEmail: 'Use another email address',
    securePasswordHint: 'Choose a secure new password',
    passwordRequirementsInfo: 'Your new password should be at least 6 characters long and different from your old password.',
    passwordUpdatedSuccess: 'Password updated successfully!',
    redirectingToLogin: 'Redirecting to login page...',
    repeatPassword: 'Repeat password',
    passwordsMatch: 'Passwords match',
    passwordsDontMatch: 'Passwords do not match',
    passwordMismatch: 'The passwords do not match',
    goToLogin: 'Go to login',

    // Auth - Confirm Email
    confirmEmail: 'Confirm Email',
    confirmEmailDesc: 'We sent you an email. Please confirm your email address.',
    resendEmail: 'Resend email',

    // Trip Creation
    createNewTrip: 'Create New Trip',
    tripName: 'Trip Name',
    destination: 'Destination',
    startDate: 'Start Date',
    endDate: 'End Date',
    addMembers: 'Add Members',
    searchUsers: 'Search users',
    tripDescription: 'Describe your trip...',
    tripNamePlaceholder: 'e.g. Amsterdam Weekend',
    destinationPlaceholder: 'e.g. Amsterdam, Netherlands',
    descriptionOptional: 'Description (optional)',
    startDateOptional: 'Start Date (optional)',
    endDateOptional: 'End Date (optional)',
    whenStart: 'When does your trip start?',
    whenEnd: 'When does your trip end?',
    addTravelCompanions: 'Add travel companions',
    searchByNameOrEmail: 'Search by name or email...',
    creatingTrip: 'Creating...',
    createTripButton: 'Create Trip',
    inviteCompanions: 'Create a trip and invite your travel companions',
    createError: 'Error creating trip',

    // Trip Members
    manageMembers: 'Manage Members',
    currentMembers: 'Current Members',
    addMember: 'Add Member',
    removeMember: 'Remove',
    selectUser: 'Select User',
    noMembers: 'No members',
    memberAdded: 'Member added',
    memberRemoved: 'Member removed',
    role: 'Role',
    owner: 'Owner',
    member: 'Member',
    allUsersAreMembersAlready: 'All available users are already members',

    // Chat
    tripChat: 'Trip Chat',
    noMessages: 'No messages yet',
    startConversation: 'Start the conversation!',
    writeMessage: 'Write a message...',
    send: 'Send',
    deleteMessage: 'Delete message?',
    edit: 'Edit',
    delete: 'Delete',
    edited: '(edited)',
    replyTo: 'Reply to',
    addReaction: 'Add reaction',
    read: 'Read',
    sent: 'Sent',
    you: 'You',

    // Friends & Invitations
    friends: 'Friends',
    friendsTab: 'Friends',
    myFriendCode: 'My Code',
    friendCodeHint: 'Share this code so others can add you as a friend',
    friendCodeCopied: 'Code copied!',
    addFriend: 'Add Friend',
    searchFriends: 'Search friends...',
    enterFriendCode: 'Enter friend code',
    friendCodePlaceholder: 'e.g. XK29FPQ3',
    sendFriendRequest: 'Send Request',
    sendingRequest: 'Sending...',
    friendRequestSent: 'Friend request sent!',
    friendRequests: 'Friend Requests',
    incomingRequests: 'Incoming',
    outgoingRequests: 'Outgoing',
    noFriendRequests: 'No pending requests',
    accept: 'Accept',
    decline: 'Decline',
    removeFriend: 'Remove Friend',
    cancelRequest: 'Cancel Request',
    friendAccepted: 'Friend request accepted!',
    friendDeclined: 'Request declined',
    friendRemoved: 'Friend removed',
    confirmRemoveFriend: 'Remove friend?',
    confirmRemoveFriendMsg: 'Are you sure you want to remove this friend?',
    noFriends: 'No friends yet',
    noFriendsHint: 'Share your code or enter a friend\'s code',
    friendAdded: 'Friend added!',
    alreadyFriends: 'Already friends',
    requestAlreadySent: 'Request already sent',
    userNotFound: 'User not found',
    cannotAddYourself: 'You cannot add yourself',
    inviteToTrip: 'Invite to Trip',
    tripInvitations: 'Trip Invitations',
    pendingTripInvites: 'Pending Trip Invites',
    noTripInvitations: 'No pending invitations',
    tripInviteSent: 'Invitation sent',
    tripInviteAccepted: 'Invitation accepted',
    tripInviteDeclined: 'Invitation declined',
    alreadyInvited: 'Already invited',
    alreadyMember: 'Already a member',
    canOnlyInviteFriends: 'Only friends can be invited',
    invitedBy: 'Invited by',
    pendingInvite: 'Pending',
    onlyFriendsCanBeAdded: 'Only friends can be added to trips',

    // Planning
    planningTab: 'Planning',
    stages: 'Stages',
    addStage: 'Add Stage',
    editStage: 'Edit Stage',
    stageName: 'Stage Name',
    stageNamePh: 'e.g. Day 1: Start → End',
    startPoint: 'Start Point',
    endPoint: 'End Point',
    distanceKm: 'Distance (km)',
    elevationGainM: 'Elevation Gain (m)',
    naismithTime: 'Naismith Time',
    gpxImport: 'Import GPX',
    gpxImportHint: 'Upload a GPX file to auto-fill distance and elevation profile',
    stageAutoCalc: 'Auto-calculate distance & elevation',
    stageCalcLoading: 'Calculating route…',
    stageCalcLocationError: 'Location not found',
    stageCalcRouteError: 'Route could not be calculated',
    stageCalcFallback: '⚠ Route unavailable – straight-line distance estimated (×1.35)',
    stageCalcElevError: 'Elevation unavailable',
    locationSearchPh: 'Search location…',
    routePreview: 'Route preview',
    overviewMap: 'All stages',
    stageMapLabel: 'Route map',
    shareStory: 'Create Story',
    downloadStory: 'Download Story',
    shareInstagramHint: 'Share to Instagram',
    stageLabel: 'Stage',
    noStages: 'No stages yet',
    noStagesHint: 'Add stages to plan your route',
    totalDistance: 'Total Distance',
    totalElevation: 'Total Elevation Gain',
    estimatedTime: 'Estimated Time',
    elevationProfile: 'Elevation Profile',
    elevationM: 'Elevation (m)',
    distanceKmAxis: 'Distance (km)',
    deleteStage: 'Delete Stage',
    saveStage: 'Save',
    cancelStage: 'Cancel',
    weather: 'Weather',
    weatherFor: 'Weather for',
    weatherLoading: 'Loading weather...',
    weatherUnavailable: 'Weather unavailable',
    precipMm: 'Precipitation',
    windKmh: 'Wind',
    trailConditions: 'Trail Conditions',
    reportCondition: 'Report Condition',
    conditionTag: 'Condition',
    conditionNote: 'Note (optional)',
    conditionGreat: 'Great',
    conditionWet: 'Wet',
    conditionMuddy: 'Muddy',
    conditionIcy: 'Icy',
    conditionOvergrown: 'Overgrown',
    conditionDamaged: 'Damaged',
    conditionClosed: 'Closed',
    conditionOther: 'Other',
    noConditions: 'No condition reports yet',
    reportedBy: 'Reported by',
    conditionForStage: 'For stage (optional)',
    allStages: 'All stages',
    submit: 'Submit',

    // Currency
    baseCurrency: 'Base Currency',
    baseCurrencyHint: 'All expenses are converted to this currency',
    expenseCurrency: 'Currency',
    exchangeRate: 'Exchange Rate',
    exchangeRateHint: '1 {currency} = ? {base}',
    currencySettings: 'Currency Settings',
    saveCurrency: 'Save',
    originalAmount: 'Original Amount',
    convertedAmount: 'Converted',
    rateLabel: 'Rate',

    // General
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
  },
  ar: {
    // UserMenu
    profile: 'الملف الشخصي',
    trips: 'الرحلات',
    logout: 'تسجيل الخروج',
    darkMode: 'الوضع الداكن',
    lightMode: 'الوضع الفاتح',
    language: 'اللغة',

    // Trips Page
    myTrips: 'رحلاتي',
    deleteTrip: 'حذف الرحلة',
    confirmDeleteTrip: 'حذف هذه الرحلة؟',
    confirmDeleteTripMsg: 'لا يمكن التراجع عن هذا الإجراء.',
    tripDeleted: 'تم حذف الرحلة',
    tripInviteAccepted2: 'تم قبول الدعوة — مرحباً بكفي الرحلة!',
    tripInviteDeclined2: 'تم رفض الدعوة',
    createTrip: 'إنشاء رحلة جديدة',
    noTrips: 'لا توجد رحلات بعد',
    startCreating: 'أنشئ رحلتك الأولى!',
    participants: 'المشاركون',
    redirecting: 'جاري التحويل...',
    backToOverview: 'العودة إلى النظرة العامة',
    loadingTrip: 'جاري تحميل الرحلة...',
    errorLoadingTrips: 'خطأ في تحميل الرحلات',
    dashboard: 'لوحة التحكم',
    tripSingular: 'رحلة',
    tripPlural: 'رحلات',
    openTrip: 'فتح الرحلة',
    travelDashboardTitle: 'نظرة عامة على الرحلات',
    travelDashboardSubtitle: 'خطط للرحلات، وأدر الأماكن، وشارك المصاريف مع الأصدقاء.',
    quickAccess: 'وصول سريع',
    manageFriends: 'إدارة الأصدقاء',
    recentTrips: 'أحدث الرحلات',
    createFirstTripHint: 'أنشئ رحلتك الأولى وادعُ الأصدقاء.',
    createFirstTrip: 'إنشاء أول رحلة',
    viewAllTrips: 'عرض كل الرحلات',
    friendsManageDesc: 'أدر أصدقاءك وأرسل الطلبات.',
    copyCode: 'نسخ الكود',
    tripInvitesDesc: 'دعوات الرحلات من أصدقائك.',
    noTripInvitationsHint: 'إذا دعاك أحد إلى رحلة، ستظهر هنا.',

    // Trip Detail
    locations: 'الأماكن',
    finances: 'المالية',
    chat: 'الدردشة',

    // Locations
    addLocation: 'إضافة مكان جديد',
    map: 'الخريطة',
    myLocations: 'أماكني',
    visited: 'تمت الزيارة',
    toVisit: 'للزيارة',
    noLocations: 'لم تتم إضافة أماكن بعد',
    addFirstLocation: 'أضف مكانك الأول!',
    selectForRoute: 'اختر للمسار',
    selectedForRoute: 'مختار للمسار',
    yourPosition: 'موقعك',
    youAreHere: 'أنت هنا',
    locationNameLabel: 'اسم المكان',
    selectCategory: 'اختر فئة',
    streetAddress: 'شارع، رقم، رمز بريدي',
    stars: 'نجوم',
    star: 'نجمة',
    alreadyVisited: 'تمت زيارته',
    saveLocation: 'حفظ المكان',
    searching: 'جاري البحث...',
    noLocationsFound: 'لم يتم العثور على أماكن',
    minCharsRequired: 'أدخل حرفين على الأقل',
    results: 'نتائج',
    result: 'نتيجة',

    // Route Planner
    routePlanning: 'تخطيط المسار',
    locationsSelected: 'أماكن مختارة',
    location: 'مكان',
    optimizeRoute: 'تحسين المسار',
    optimizing: 'جاري التحسين...',
    startNavigation: 'بدء الملاحة',
    chooseNavigation: 'اختر الملاحة',
    selectMinTwo: 'اختر مكانين على الأقل لتحسين المسار',
    allLocations: 'جميع الأماكن',
    firstLocationOnly: 'الأول فقط',

    // Location Categories
    restaurant: 'مطعم',
    cafe: 'مقهى',
    museum: 'متحف',
    park: 'حديقة',
    attraction: 'معلم سياحي',
    shopping: 'تسوق',
    bar: 'بار',
    hotel: 'فندق',
    other: 'أخرى',

    // Location Form
    locationName: 'اسم المكان',
    category: 'الفئة',
    address: 'العنوان',
    rating: 'التقييم',
    notes: 'ملاحظات',
    save: 'حفظ',
    cancel: 'إلغاء',

    // Finances
    expenses: 'المصروفات',
    newExpense: 'إضافة مصروف جديد',
    noExpenses: 'لا توجد مصروفات بعد',
    addFirstExpense: 'أضف مصروفك الأول!',
    totalExpenses: 'إجمالي المصروفات',
    perPerson: 'لكل شخص',
    members: 'الأعضاء',
    exportPDF: 'تصدير PDF (مع الإيصالات)',
    exportCSV: 'تصدير CSV',
    description: 'الوصف',
    amount: 'المبلغ',
    paidBy: 'دفع من قبل',
    expenseDate: 'التاريخ',
    receipt: 'الإيصال',
    uploadReceipt: 'رفع إيصال',
    hasReceipt: 'يوجد إيصال',
    viewReceipt: 'عرض الإيصال',
    hideReceipt: 'إخفاء الإيصال',
    openFullscreen: 'فتح بشاشة كاملة',
    selectParticipants: 'اختر المشاركين',
    splitEqually: 'تقسيم متساوي',
    debtSettlement: 'تسوية الديون',
    whoPaysWhom: 'من يدفع لمن',
    youOwe: 'أنت مدين بـ',
    owesYou: 'مدين لك',
    settled: 'تمت التسوية',
    expensesByCategory: 'المصروفات حسب الفئة',
    expensesOverTime: 'المصروفات عبر الوقت',
    selectPerson: 'اختر شخص',
    saveExpense: 'حفظ المصروف',
    amountEur: 'المبلغ (€)',
    clickToUpload: 'اضغط للرفع أو اسحب الملف هنا',
    maxFileSize: 'PNG, JPG حتى 5MB',
    splitAmong: 'تقسيم بين',
    person: 'شخص',
    persons: 'أشخاص',
    collapse: 'طي',
    selectedOf: 'من',
    selected: 'مختار',
    deselectAll: 'إلغاء تحديد الكل',
    selectAll: 'تحديد الكل',
    fileTooLarge: 'الملف كبير جداً. الحد الأقصى 5MB.',
    onlyImages: 'يسمح فقط بالصور.',
    createdBy: 'بواسطة',
    unknown: 'غير معروف',
    avgPerDay: 'المعدل/يوم',
    highestExpense: 'أعلى مصروف',

    // Debt Settlement
    debtSettlementTitle: 'التسوية والديون',
    balance: 'الرصيد',
    paid: 'مدفوع',
    share: 'الحصة',
    getsBack: 'يستعيد',
    owes: 'مدين',
    fullySettled: 'تمت التسوية بالكامل!',
    openPayments: 'مدفوعات مفتوحة',
    allDebtsSettled: 'تم تسوية جميع الديون!',
    noOneOwes: 'لا أحد مدين لأحد.',
    pays: 'يدفع',
    receives: 'يستلم',
    settlementTip: 'التسوية محسنة وتقلل عدد المعاملات المطلوبة.',

    // Trip Finance Overview
    tripOverview: 'نظرة عامة على الرحلة',
    myTotalExpenses: 'إجمالي مصروفاتي',
    overviewByParticipant: 'نظرة عامة حسب المشارك',
    gets: 'يحصل',
    // Finance Overview
    totalExpensesSubtitle: 'جميع مصاريف هذه الرحلة',
    totalAmount: 'المبلغ الإجمالي',
    totalAmountSubtitle: 'مجموع جميع المصاريف',
    participantsSubtitle: 'أشخاص في هذه الرحلة',
    avgPerPerson: 'متوسط للشخص',
    avgPerPersonSubtitle: 'توزيع متساوٍ',
    sharePerParticipant: 'حصة كل مشارك',
    paymentView: 'عرض المدفوعات',
    paymentViewSubtitle: 'المدفوع والمستحق لكل شخص',
    morePaid: '% أكثر من الحصة',
    stillOpen: '% لا يزال مفتوحاً',
    owesStill: 'مدين',

    // Expense Categories
    food: 'طعام',
    transport: 'مواصلات',
    accommodation: 'إقامة',
    activities: 'أنشطة',
    groceries: 'بقالة',
    entertainment: 'ترفيه',

    // Profile
    profileSettings: 'إعدادات الملف الشخصي',
    personalInfo: 'المعلومات الشخصية',
    displayName: 'اسم العرض',
    email: 'البريد الإلكتروني',
    profilePicture: 'صورة الملف الشخصي',
    uploadNewPicture: 'رفع صورة جديدة',
    removePicture: 'إزالة الصورة',
    updateProfile: 'تحديث الملف الشخصي',
    accountSettings: 'إعدادات الحساب',
    changePassword: 'تغيير كلمة المرور',
    deleteAccount: 'حذف الحساب',
    back: 'رجوع',
    editProfile: 'تعديل الملف الشخصي',
    bio: 'نبذة',
    website: 'الموقع الإلكتروني',
    joined: 'انضم',
    saveChanges: 'حفظ التغييرات',
    saving: 'جاري الحفظ...',
    newPassword: 'كلمة مرور جديدة',
    confirmPassword: 'تأكيد كلمة المرور الجديدة',
    updatePassword: 'تحديث كلمة المرور',
    changing: 'جاري التغيير...',
    clickToUploadAvatar: 'اضغط لرفع صورة جديدة',
    maxAvatarSize: 'الحد الأقصى 2MB (JPG, PNG)',
    manageProfileSecurity: 'إدارة معلومات الملف الشخصي والأمان',
    keepAccountSecure: 'قم بتحديث كلمة المرور للحفاظ على أمان حسابك',
    passwordsNoMatch: 'كلمات المرور الجديدة غير متطابقة!',
    passwordTooShort: 'يجب أن تكون كلمة المرور 6 أحرف على الأقل!',
    profileUpdated: 'تم تحديث الملف الشخصي بنجاح!',
    profileUpdateFailed: 'فشل تحديث الملف الشخصي.',
    passwordChanged: 'تم تغيير كلمة المرور بنجاح!',
    passwordChangeFailed: 'فشل تغيير كلمة المرور.',
    avatarUpdated: 'تم تحديث الصورة بنجاح!',
    avatarUploadFailed: 'فشل رفع الصورة.',
    uploadImageOnly: 'يرجى رفع ملف صورة.',
    imageTooLarge: 'يجب أن تكون الصورة أقل من 2MB.',
    loadingProfile: 'جاري تحميل الملف الشخصي...',
    enterName: 'أدخل اسمك',
    aboutYou: 'أخبرنا عن نفسك',
    searchYourLocation: 'ابحث عن موقعك...',

    // Auth - Signup
    createAccount: 'إنشاء حساب',
    createYourAccount: 'أنشئ حساب Finance App الخاص بك',
    accountCreated: 'تم إنشاء الحساب بنجاح! جاري التحويل...',
    continueWithGoogle: 'المتابعة مع Google',
    continueWithApple: 'المتابعة مع Apple',
    continueWithGithub: 'المتابعة مع GitHub',
    orWithEmail: 'أو بالبريد الإلكتروني',
    name: 'الاسم',
    password: 'كلمة المرور',
    yourName: 'اسمك',
    yourEmail: 'بريدك@email.com',
    minChars: '6 أحرف على الأقل',
    minCharsRequired2: 'مطلوب 6 أحرف على الأقل',
    creating: 'جاري الإنشاء...',
    alreadyHaveAccount: 'لديك حساب بالفعل؟',
    signIn: 'تسجيل الدخول',
    genericError: 'حدث خطأ',
    notLoggedIn: 'غير مسجل الدخول',

    // Auth - Login
    loginTitle: 'مرحباً بعودتك',
    loginSubtitle: 'سجل الدخول إلى حسابك',
    forgotPassword: 'نسيت كلمة المرور؟',
    noAccount: 'ليس لديك حساب؟',
    signUp: 'إنشاء حساب',
    loggingIn: 'جاري تسجيل الدخول...',

    // Auth - Reset Password
    resetPassword: 'إعادة تعيين كلمة المرور',
    resetPasswordDesc: 'أدخل بريدك الإلكتروني وسنرسل لك رابط إعادة التعيين.',
    sendResetLink: 'إرسال رابط',
    sending: 'جاري الإرسال...',
    resetLinkSent: 'أرسلنا لك بريداً إلكترونياً يحتوي على رابط لإعادة تعيين كلمة المرور. يرجى التحقق من صندوق الوارد.',
    backToLogin: 'العودة لتسجيل الدخول',

    // Auth - Update Password
    setNewPassword: 'تعيين كلمة مرور جديدة',
    setNewPasswordDesc: 'أدخل كلمة المرور الجديدة.',
    passwordUpdated: 'تم تحديث كلمة المرور بنجاح! جاري التحويل...',
    updatingPassword: 'جاري التحديث...',
    invalidResetLink: 'رابط غير صالح أو منتهي الصلاحية. يرجى طلب رابط جديد.',
    requestNewLink: 'طلب رابط جديد',
    emailAddressLabel: 'عنوان البريد الإلكتروني',
    checkYourEmail: 'تحقق من بريدك الإلكتروني',
    enterEmailAddress: 'أدخل عنوان بريدك الإلكتروني',
    emailSentTitle: 'تم إرسال البريد الإلكتروني!',
    openMailbox: 'افتح صندوق بريدك الوارد',
    clickEmailLink: 'انقر على الرابط في البريد الإلكتروني',
    useOtherEmail: 'استخدم عنواناً بريدياً آخر',
    securePasswordHint: 'اختر كلمة مرور جديدة آمنة',
    passwordRequirementsInfo: 'يجب أن تكون كلمة مرورك 6 أحرف على الأقل وتختلف عن كلمة مرورك القديمة.',
    passwordUpdatedSuccess: 'تم تحديث كلمة المرور بنجاح!',
    redirectingToLogin: 'جاري التحويل لصفحة تسجيل الدخول...',
    repeatPassword: 'كرر كلمة المرور',
    passwordsMatch: 'كلمات المرور متطابقة',
    passwordsDontMatch: 'كلمات المرور غير متطابقة',
    passwordMismatch: 'كلمات المرور غير متطابقة',
    goToLogin: 'إلى تسجيل الدخول',

    // Auth - Confirm Email
    confirmEmail: 'تأكيد البريد الإلكتروني',
    confirmEmailDesc: 'أرسلنا لك بريداً إلكترونياً. يرجى تأكيد عنوان بريدك الإلكتروني.',
    resendEmail: 'إعادة إرسال البريد',

    // Trip Creation
    createNewTrip: 'إنشاء رحلة جديدة',
    tripName: 'اسم الرحلة',
    destination: 'الوجهة',
    startDate: 'تاريخ البداية',
    endDate: 'تاريخ النهاية',
    addMembers: 'إضافة أعضاء',
    searchUsers: 'بحث عن مستخدمين',
    tripDescription: 'وصف رحلتك...',
    tripNamePlaceholder: 'مثل: عطلة نهاية الأسبوع في أمستردام',
    destinationPlaceholder: 'مثل: أمستردام، هولندا',
    descriptionOptional: 'الوصف (اختياري)',
    startDateOptional: 'تاريخ البداية (اختياري)',
    endDateOptional: 'تاريخ النهاية (اختياري)',
    whenStart: 'متى تبدأ رحلتك؟',
    whenEnd: 'متى تنتهي رحلتك؟',
    addTravelCompanions: 'إضافة رفاق السفر',
    searchByNameOrEmail: 'البحث بالاسم أو البريد الإلكتروني...',
    creatingTrip: 'جاري الإنشاء...',
    createTripButton: 'إنشاء رحلة',
    inviteCompanions: 'أنشئ رحلة وادعُ رفاق سفرك',
    createError: 'خطأ في إنشاء الرحلة',

    // Trip Members
    manageMembers: 'إدارة الأعضاء',
    currentMembers: 'الأعضاء الحاليون',
    addMember: 'إضافة عضو',
    removeMember: 'إزالة',
    selectUser: 'اختر مستخدم',
    noMembers: 'لا يوجد أعضاء',
    memberAdded: 'تمت إضافة العضو',
    memberRemoved: 'تمت إزالة العضو',
    role: 'الدور',
    owner: 'المالك',
    member: 'عضو',
    allUsersAreMembersAlready: 'جميع المستخدمين المتاحين أعضاء بالفعل',

    // Chat
    tripChat: 'دردشة الرحلة',
    noMessages: 'لا توجد رسائل بعد',
    startConversation: 'ابدأ المحادثة!',
    writeMessage: 'اكتب رسالة...',
    send: 'إرسال',
    deleteMessage: 'حذف الرسالة؟',
    edit: 'تعديل',
    delete: 'حذف',
    edited: '(تم التعديل)',
    replyTo: 'الرد على',
    addReaction: 'إضافة تفاعل',
    read: 'مقروء',
    sent: 'مرسل',
    you: 'أنت',

    // Friends & Invitations
    friends: 'أصدقاء',
    friendsTab: 'أصدقاء',
    myFriendCode: 'كودي',
    friendCodeHint: 'شارك هذا الكود حتى يتمكن الآخرون من إضافتك كصديق',
    friendCodeCopied: 'تم نسخ الكود!',
    addFriend: 'إضافة صديق',
    searchFriends: 'البحث عن الأصدقاء...',
    enterFriendCode: 'أدخل كود الصديق',
    friendCodePlaceholder: 'مثل: XK29FPQ3',
    sendFriendRequest: 'إرسال طلب',
    sendingRequest: 'جاري الإرسال...',
    friendRequestSent: 'تم إرسال طلب الصداقة!',
    friendRequests: 'طلبات الصداقة',
    incomingRequests: 'واردة',
    outgoingRequests: 'صادرة',
    noFriendRequests: 'لا توجد طلبات معلقة',
    accept: 'قبول',
    decline: 'رفض',
    removeFriend: 'إزالة الصديق',
    cancelRequest: 'إلغاء الطلب',
    friendAccepted: 'تم قبول طلب الصداقة!',
    friendDeclined: 'تم رفض الطلب',
    friendRemoved: 'تمت إزالة الصديق',
    confirmRemoveFriend: 'إزالة الصديق؟',
    confirmRemoveFriendMsg: 'هل تريد حقاً إزالة هذا الصديق؟',
    noFriends: 'لا أصدقاء بعد',
    noFriendsHint: 'شارك كودك أو أدخل كود صديق',
    friendAdded: 'تمت إضافة الصديق!',
    alreadyFriends: 'أنتم أصدقاء بالفعل',
    requestAlreadySent: 'تم إرسال الطلب بالفعل',
    userNotFound: 'المستخدم غير موجود',
    cannotAddYourself: 'لا يمكنك إضافة نفسك',
    inviteToTrip: 'دعوة للرحلة',
    tripInvitations: 'دعوات الرحلة',
    pendingTripInvites: 'دعوات الرحلة المعلقة',
    noTripInvitations: 'لا توجد دعوات معلقة',
    tripInviteSent: 'تم إرسال الدعوة',
    tripInviteAccepted: 'تم قبول الدعوة',
    tripInviteDeclined: 'تم رفض الدعوة',
    alreadyInvited: 'مدعو بالفعل',
    alreadyMember: 'عضو بالفعل',
    canOnlyInviteFriends: 'يمكن دعوة الأصدقاء فقط',
    invitedBy: 'مدعو من قبل',
    pendingInvite: 'معلق',
    onlyFriendsCanBeAdded: 'يمكن إضافة الأصدقاء فقط إلى الرحلات',

    // Planning
    planningTab: 'التخطيط',
    stages: 'المراحل',
    addStage: 'إضافة مرحلة',
    editStage: 'تعديل مرحلة',
    stageName: 'اسم المرحلة',
    stageNamePh: 'مثال: اليوم 1: البداية ← النهاية',
    startPoint: 'نقطة البداية',
    endPoint: 'نقطة النهاية',
    distanceKm: 'المسافة (km)',
    elevationGainM: 'ارتفاع الصعود (m)',
    naismithTime: 'وقت Naismith',
    gpxImport: 'استيراد GPX',
    gpxImportHint: 'ارفع ملف GPX لملء المسافة وملف الارتفاع تلقائياً',
    stageAutoCalc: 'احسب المسافة والارتفاع تلقائياً',
    stageCalcLoading: 'جاري حساب المسار…',
    stageCalcLocationError: 'الموقع غير موجود',
    stageCalcRouteError: 'تعذر حساب المسار',
    stageCalcFallback: '⚠ المسار غير متاح – تم حساب مسافة الخط المستقيم (×1.35)',
    stageCalcElevError: 'الارتفاع غير متاح',
    locationSearchPh: 'ابحث عن موقع…',
    routePreview: 'معاينة المسار',
    overviewMap: 'جميع المراحل',
    stageMapLabel: 'خريطة المسار',
    shareStory: 'إنشاء قصة',
    downloadStory: 'تنزيل القصة',
    shareInstagramHint: 'مشاركة على إنستقرام',
    stageLabel: 'مرحلة',
    noStages: 'لا توجد مراحل بعد',
    noStagesHint: 'أضف مراحل لتخطيط المسار',
    totalDistance: 'إجمالي المسافة',
    totalElevation: 'إجمالي الارتفاع',
    estimatedTime: 'الوقت المقدر',
    elevationProfile: 'ملف الارتفاع',
    elevationM: 'الارتفاع (m)',
    distanceKmAxis: 'المسافة (km)',
    deleteStage: 'حذف المرحلة',
    saveStage: 'حفظ',
    cancelStage: 'إلغاء',
    weather: 'الطقس',
    weatherFor: 'الطقس لـ',
    weatherLoading: 'جاري تحميل الطقس...',
    weatherUnavailable: 'الطقس غير متاح',
    precipMm: 'هطول الأمطار',
    windKmh: 'الرياح',
    trailConditions: 'حالة المسار',
    reportCondition: 'الإبلاغ عن حالة',
    conditionTag: 'الحالة',
    conditionNote: 'ملاحظة (اختياري)',
    conditionGreat: 'ممتاز',
    conditionWet: 'مبلل',
    conditionMuddy: 'طيني',
    conditionIcy: 'جليدي',
    conditionOvergrown: 'متشعب',
    conditionDamaged: 'تالف',
    conditionClosed: 'مغلق',
    conditionOther: 'أخرى',
    noConditions: 'لا توجد تقارير حالة بعد',
    reportedBy: 'أبلغ من قبل',
    conditionForStage: 'للمرحلة (اختياري)',
    allStages: 'كل المراحل',
    submit: 'إرسال',

    // Currency
    baseCurrency: 'العملة الأساسية',
    baseCurrencyHint: 'تحوّل جميع المصاريف إلى هذه العملة',
    expenseCurrency: 'العملة',
    exchangeRate: 'سعر الصرف',
    exchangeRateHint: '1 {currency} = ? {base}',
    currencySettings: 'إعدادات العملة',
    saveCurrency: 'حفظ',
    originalAmount: 'المبلغ الأصلي',
    convertedAmount: 'محوّل',
    rateLabel: 'السعر',

    // General
    loading: 'جاري التحميل...',
    error: 'خطأ',
    success: 'نجح',
  },
} as const;

export type Language = keyof typeof translations;
export type TranslationKey = keyof typeof translations.de;

export function useTranslations(lang: Language = 'de') {
  return translations[lang] || translations.de;
}
